import { Component, OnInit } from '@angular/core';
import { UtilsService } from '../utils.service'
import { RuntimeService } from '../runtime.service'
import { SortService } from '../sort.service'
import { CriterionService } from '../criterion.service'
import { AdminService } from '../admin.service'

@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.css']
})
export class AdminDashboardComponent implements OnInit {


  constructor(
    private rts: RuntimeService,
    public utils: UtilsService,
    private ss: SortService,
    private cs: CriterionService,
    private ads: AdminService
  ) { }

  ngOnInit() {
  }

  get currentProjectShortcut() {
    if (!this.rts.currentProject)
      return ''
    return ` [${this.rts.currentProject.shortcut}]`
  }

  uploadSearchFilesSwitch() {
    this.ads.clearSwitches()
    this.ads.uploadSearchFilesOn = true
  }

  uploadBatchSearchSwitch() {
    this.ads.clearSwitches()
    this.ads.uploadBatchSearchOn = true
  }

  editCriterionSwitch() {
    this.ads.clearSwitches()
  }

  newTopicSwitch() {
    this.ads.clearSwitches()
    this.ads.newTopicOn = true
  }

  newTagSwitch() {
    this.ads.clearSwitches()
    this.ads.newTagOn = true
  }

  newCriterionSwitch() {
    this.ads.clearSwitches()
    this.ads.newCriterionOn = true
  }

  newSearchTermSwitch() {
    this.ads.clearSwitches()
    this.ads.newSearchTermOn = true
  }
}



// WEBPACK FOOTER //
// ./src/app/admin-dashboard/admin-dashboard.component.ts